<template>
   <b-container class="form-container bg-white shadow">
    <h3 class="col-12 text-dark py-4 mb-0">{{edit ? 'Edit' : 'Create' }} User</h3>
    <AccountForm
      v-if="!edit || (edit && user)"
      :allowCancel="true"
      :edit="edit"
      :isAdmin="true"
      :role="userRole"
      :initialAccount="edit ? user : newUser"
      cancelRouteName="userManagement"
      @submitted="submitSuccess"
    />
    <b-modal
      ref="accountUpdatedModal"
      id="accountUpdatedModal"
      centered
      :title="`User ${edit ? 'Updated' : 'Created'}`"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      @ok="$router.push({ name: 'userManagement' })"
    >
      <template v-if="edit">The user was successfully updated.</template>
      <template v-else>The user was successfully created.<br/>A message has been sent to the provided email address so they may access their account.</template>
      <template v-slot:modal-footer="{ ok }">
        <b-button pill variant="primary" class="full-width text-center" @click="ok()" aria-label="Confirm user creation">
          Ok
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import { initialAddress } from '@/helpers';
import AccountForm from '@/components/account/AccountForm.vue';

export default {
  name: 'AdminUser',
  components: {
    AccountForm,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newUser: {
        physicalAddress: initialAddress(),
        mailingAddress: initialAddress(),
      },
    };
  },
  created() {
    this.$store.dispatch('Admin/unload');
    if (this.edit) {
      this.$store.dispatch('Admin/getUser', this.$route.params.id);
    }
  },
  computed: {
    ...mapState('Admin', {
      user: state => state.user,
    }),
    userRole() {
      if (this.user) {
        return this.user.roles.length > 0 ? this.user.roles[0] : 'public';
      }

      return this.$route.params.type ? this.$route.params.type : 'public';
    },
  },
  methods: {
    submitSuccess() {
      this.$refs.accountUpdatedModal.show();
    },
  },
};
</script>
